import { useState, useEffect } from 'react';

interface Props {
  releaseAt: string;
  warningWindowMinutes: number;
}

function computeMinutes(releaseAt: string): number {
  return Math.floor((new Date(releaseAt).getTime() - Date.now()) / 60000);
}

export function ReleaseCountdownChip({ releaseAt, warningWindowMinutes }: Props) {
  const [minutes, setMinutes] = useState(() => computeMinutes(releaseAt));

  useEffect(() => {
    const id = setInterval(() => setMinutes(computeMinutes(releaseAt)), 30_000);
    return () => clearInterval(id);
  }, [releaseAt]);

  if (minutes > warningWindowMinutes) return null;

  const isUrgent = minutes <= 10;
  const label = minutes <= 0 ? 'Releasing…' : `Releases in ${minutes}m`;

  return (
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        padding: '1px 5px',
        borderRadius: 3,
        fontSize: 9,
        fontWeight: 700,
        lineHeight: 1.4,
        letterSpacing: '0.02em',
        background: isUrgent ? '#dc2626' : '#d97706',
        color: '#fff',
        whiteSpace: 'nowrap',
      }}
    >
      {label}
    </span>
  );
}
